import type { SanityPageBuilderContentGalleryItem, SanityPageBuilderContentGallerySection, SanityPageBuilderContentGallerySpec, SanityPageBuilderSection } from "@ouster/shared";
import { ContentGalleryBlockView, type ContentGalleryBlockViewItem } from "~/features/blocks/inventory/content-gallery";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityMediaFigure, hasRenderableSanityMedia } from "~/features/sanity/page-builder/sections/media-figure";
import { SanityRichText } from "~/features/sanity/rich-text";
import type { Mode } from "~/features/ui/get-theme-style";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderContentGallerySection;
  };
};
type ContentGalleryViewItem = ContentGalleryBlockViewItem<SanityPageBuilderContentGallerySpec> & Pick<SanityPageBuilderContentGalleryItem, "_key">;
export function SanityContentGallerySection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const items = sectionContent.items?.map<ContentGalleryViewItem>(item => ({
    _key: item._key,
    description: item.description?.length ? <SanityRichText value={item.description} /> : undefined,
    link: toCraftLinkArray(item.link),
    media: hasRenderableSanityMedia(item.media) ? <SanityMediaFigure media={item.media} fit="cover" /> : undefined,
    specs: item.specs,
    title: item.title
  })) ?? [];
  return <ContentGalleryBlockView<SanityPageBuilderContentGallerySpec, ContentGalleryViewItem> anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getItemKey={(item, index) => item._key || index} getSpecKey={(spec, index) => spec._key ? `${spec._key}-${index}` : index} hasCounters={sectionContent.hasCounters} hasTopDivider={sectionSettings?.hasTopDivider ?? true} isHighlighted={sectionContent.isHighlighted} items={items} mode={mode} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}